/**
 * SELECT-TEMPLATE.MODAL
 * Pick a template in order to launch a project
 */
import Modal from "@/components/modal"
import Scroller from "@/components/scroller"
import { useState } from "react"
import { withTranslation, WithTranslation } from "react-i18next"
import TemplatesWidget from "@/widgets/templates.widget"
import AddTemplateModal from "./add-template.modal"

interface OwnProps {
  onClose: Function
  onSelect?: Function
}

type Props = OwnProps & WithTranslation

const MODAL_ADD: string = "MODAL_ADD"

function SelectTemplateModal(props: Props) {
  const { t } = props

  const [currentModal, setCurrentModal] = useState<string | null>(null)

  //Select template
  function select(templateId) {
    if (props.onSelect) {
      props.onSelect(templateId)
    }
  }

  return (
    <Modal onClose={() => props.onClose()} isCloseButtonVisible isLarge title={t("template_select")}>
      {currentModal === MODAL_ADD && <AddTemplateModal onClose={() => setCurrentModal(null)} />}

      <Scroller style={{ height: "calc(100vh - 300px)" }} isModalScroller>
        <TemplatesWidget switchForProject onSelect={select} />
      </Scroller>
    </Modal>
  )
}

export default withTranslation()(SelectTemplateModal)
